import React, { createContext, useContext, ReactNode, useMemo } from 'react'

// Define the shape of the context data
interface CalendarContextType { }

// Create the context with a default value
const CalendarContext = createContext<CalendarContextType | undefined>(undefined)

interface CalendarProviderProps {
  children: ReactNode
}

// Create the Provider component
export const CalendarProvider: React.FC<CalendarProviderProps> = ({
  children,
}) => {

  // Memoize the context value
  const contextValue = useMemo(() => ({ }), [])

  return (
    <CalendarContext.Provider value={contextValue}>
      {children}
    </CalendarContext.Provider>
  )
}

// Create a custom hook for easy consumption
export const useCalendarEvents = (): CalendarContextType => {
  const context = useContext(CalendarContext)
  if (context === undefined) {
    throw new Error('useCalendarEvents must be used within a CalendarProvider')
  }
  return context
}
